export const ROUTE_CONSTANTS = {
    PRIVACY_POLICY: '/privacypolicy',
    PRIZE_TC: '/prize-tc',
    TERMS_CONDITIONS: '/terms-conditions',
    HZM_POOL_ACCOUNT_DELETE: '/hzm/pool/account-delete',
}